<template>
  <footer>
    <div class="o-container o-container--xlarge">
      <div class="h-card vcard">
        <p>
          <a>
            <img
              class="u-logo"
              src="@/assets/images/Logo_BEX_Neutral_Metall_RGB.svg"
              width="209"
            />
          </a>
        </p>

        <p>
          <span class="card-group">
            <span class="p-name">{{ $t('components.footer.hcard.name') }}</span>
          </span>
          <span class="card-group">
            <span class="p-street-address">{{
              $t('components.footer.hcard.streetAddress')
            }}</span>
          </span>
          <span class="card-group">{{ $t('components.footer.postbox') }}</span>
          <span class="card-group">
            <span class="p-post-office-box">{{
              $t('components.footer.hcard.postOfficeBox')
            }}</span>
            <span class="sr-only p-postal-code">{{
              $t('components.footer.hcard.postalCode')
            }}</span>
            <span class="sr-only p-locality">{{
              $t('components.footer.hcard.locality')
            }}</span>
            <span class="sr-only p-region">{{
              $t('components.footer.hcard.region')
            }}</span>
            <span class="sr-only p-country-name">{{
              $t('components.footer.hcard.countryName')
            }}</span>
            <span class="sr-only p-url">{{
              $t('components.footer.hcard.url')
            }}</span>
          </span>
          <br class="u-display-none u-display-block@large" />
          <span class="card-group">
            {{ $t('components.footer.tel') }}
            <a class="p-tel" href="tel:+41313401111">+41 31 340 11 11</a>
          </span>
        </p>

        <nav class="meta-navigation">
          <ul>
            <router-link
              v-for="link in metanavi"
              :key="link.name"
              :class="[`meta-navigation-link--${link.name.toLowerCase()}`]"
              :to="{ name: link.name }"
              tag="li"
            >
              <a class="metanavi-link"
                ><font-awesome-icon
                  v-if="link.iconBefore"
                  class="icon-before"
                  :icon="link.iconBefore"/>{{
                  $t(`components.footer.link.${link.name}`)
                }}<font-awesome-icon
                  v-if="link.iconAfter"
                  class="icon-after"
                  :icon="link.iconAfter"
              /></a>
            </router-link>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>
import { getRouteByName } from '@/assets/js/helper'

export default {
  name: 'BosFooter',
  data() {
    return {
      metanavi: [
        {
          name: getRouteByName('Imprint').name
        },
        {
          name: getRouteByName('DataProtection').name
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$footer-padding: 4.5rem 0 !default;
$footer-bg: #f6f6f6 !default;
$footer-font-size: 1rem !default;
$footer-color: #BBA868 !default;
$footer-line-height: 1.5 !default;

$footer-listitem-padding: 0 1em !default;

$footer-cardgroup-seperator: '●' !default;
$footer-cardgroup-padding: 0.6em !default;

$footer-mobile-padding: 4rem 0 !default;
$footer-mobile-font-size: $footer-font-size * 0.8 !default;

footer {
  position: relative;
  margin-top: auto;
  padding: $footer-padding;
  width: 100%;
  background-color: $footer-bg;
  font-size: $footer-font-size;
  font-weight: 300;
  font-style: normal;
  color: $footer-color;
  text-align: center;
  line-height: $footer-line-height;

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    height: auto;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ul {
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      padding: $footer-listitem-padding;
    }
  }

  .h-card {
    .card-group {
      display: inline-block;

      + .card-group {
        &:before {
          display: inline-block;
          content: $footer-cardgroup-seperator;
          padding-left: $footer-cardgroup-padding;
          padding-right: $footer-cardgroup-padding;
        }
      }
    }
  }

  .md &,
  .sm &,
  .xs & {
    padding: $footer-mobile-padding;
    font-size: $footer-mobile-font-size;

    ul {
      display: block;
    }

    .h-card {
      .card-group {
        display: block;

        &:before {
          display: none;
        }
      }
    }
  }

  @media print {
    padding: 0 !important;
    border-top: 2px solid #979797;

    .h-card {
      .u-logo {
        display: none;
      }
    }

    .meta-navigation {
      display: none;
    }
  }
}
</style>
